import { LOAD_DRAFT } from '../constants';
import { draft } from '../../resources/draft';

import {
  loadDraftEmpty,
  loadDraftSuccess,
  loadDraftError,
  replaceDraftState
} from '../draft/actions';
import { getExamData } from '../examData/actions';
import { completeSTEPAPPLICANTTYPESelector } from '../step/selectors';
import { giaSelectedSelector } from '../gia/selectors';
import { sendCMAAppealTechError } from '../../helpers/CMAStats';

const loadDraftMiddleware = ({ dispatch, getState }) => next => action => {
  const { type } = action;

  if (type !== LOAD_DRAFT || !draft) {
    return next(action);
  }

  draft
    .fetchList()
    .then(({ list }) => {
      const autoDraft = Object.values(list).find(
        item => item.version === 'auto.appeal'
      );

      if (autoDraft) {
        draft
          .loadAuto()
          .then(result => {
            dispatch(replaceDraftState(result));
            dispatch(loadDraftSuccess(result));

            const state = getState();
            const applicantTypeComplete = completeSTEPAPPLICANTTYPESelector(
              state
            );
            const giaSelected = giaSelectedSelector(state);

            if (applicantTypeComplete) {
              dispatch(
                getExamData({
                  giaNumber: giaSelected.document_number.value,
                  giaCode: giaSelected.registration_code.value,
                  saveApprove: true
                })
              );
            }
          })
          .catch(() => {
            sendCMAAppealTechError({ stage: 'start' });
            return dispatch(loadDraftError());
          });
      } else {
        dispatch(loadDraftEmpty());
      }
    })
    .catch(() => {
      sendCMAAppealTechError({ stage: 'start' });
      return dispatch(loadDraftError());
    });

  return next(action);
};

export default loadDraftMiddleware;
